/* eslint-disable @typescript-eslint/no-unused-vars */
/* global console setInterval, clearInterval */

/**
 * Determines gender from name
 * @customfunction
 * @helpurl https://excel.genderapi.io/help/gender_from_name.html
 * @param {string} name First name or Full name.
 * @param {boolean} [enable_additional_info] Set to 1 to return extended metadata.
 * @param {string} [country] Country Filter ex:TR, US, UK.
 * @returns {string[][]} Returns male, female, or null.
 */
async function FROM_NAME(name,enable_additional_info, country) {
    return new Promise(function (resolve, reject) {
    getGenderData(name, country,enable_additional_info)
        .then(function (json) {
          resolve(json);
        })
  })

}

/**
 * Determines gender from email
 * @customfunction
 * @helpurl https://excel.genderapi.io/help/gender_from_email.html
 * @param {string} email E-Mail.
 * @param {boolean} [enable_additional_info] Set to 1 to return extended metadata.
 * @param {string} [country] Country Filter ex:TR, US, UK.
 * @returns {string[][]} Returns male, female, or null.
 */
function FROM_EMAIL(email,enable_additional_info, country) {
  return new Promise(function (resolve, reject) {
    getGenderData(email, country,enable_additional_info,"email")
        .then(function (json) {
          resolve(json);
        })
  })
}

/**
 * Determines gender from username
 * @customfunction
 * @helpurl https://excel.genderapi.io/help/gender_from_username.html
 * @param {string} username Username.
 * @param {boolean} [enable_additional_info] Set to 1 to return extended metadata.
 * @param {string} [country] Country Filter ex:TR, US, UK.
 * @returns {string[][]} Returns male, female, or null.
 */
function FROM_USERNAME(username,enable_additional_info, country) {
  return new Promise(function (resolve, reject) {
    getGenderData(username, country,enable_additional_info,"username")
        .then(function (json) {

          resolve(json);
        })
  })
}


async function getGenderData(input, country , enable_additional_info ,type="name") {

    if(!input){
        return [["error: Input is empty"]];
    }
    let apiKey=await getItem("genderapi_key");

    if(!apiKey){
        return [["error: API key not set: Open GenderAPI Sidebar -> Set API Key"]];
    }







  if(!country){
    country = "";
  }
  if(!enable_additional_info){
    enable_additional_info = false;
  }else {
    enable_additional_info = true;
  }
  let url = "https://api.genderapi.io/api";

  if(type === "name") {
    url = "https://api.genderapi.io/api?name="+encodeURIComponent(input);
  }
  else if(type === "username") {
    url = "https://api.genderapi.io/api/username?username="+encodeURIComponent(input);
  }
  else if(type === "email") {
    url = "https://api.genderapi.io/api/email?email="+encodeURIComponent(input);
  }

  url=url+"&key="+apiKey;

  if(country){
      url=url+"&country="+country
  }





    try {
        const response = await fetch(url);
        const json = await response.json();

        if(!json.status){
            return [[json.errmsg]];
        }

        let result = [[json.gender]];
        if (enable_additional_info) {
            result[0].push(json.probability);
            result[0].push(json.country);
            result[0].push(json.name);
        }
        return result;
    } catch (error) {
        return[["unknown error"]];  // İstersen reject(error) da yapabilirsin
    }

}


async function getItem(key) {
    try {
        const value = await OfficeRuntime.storage.getItem(key);
        if (value) {
            return value;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}





CustomFunctions.associate("FROM_NAME", FROM_NAME);
CustomFunctions.associate("FROM_EMAIL", FROM_EMAIL);
CustomFunctions.associate("FROM_USERNAME", FROM_USERNAME);